import IconBack from '../../../audi-ui-components/icons/Back';
import Geofence from "../../../audi-ui-components/icons/Geofence";
import DirectMail from "../../../audi-ui-components/icons/DirectMail";
import VoiceCall1 from "../../../audi-ui-components/icons/VoiceCall1";
import RatingStar from "./RatingStar";
import Home from "../../../audi-ui-components/icons/Home";
import Button from '../../../audi-ui-components/Button';
import { parse as phoneParse } from 'libphonenumber-js';

const Location = ({
    id,
    dealer,
    type,
    name,
    address,
    suburb,
    state,
    postcode,
    phone,
    email,
    emailLinkText,
    website,
    websiteLinkText,
    webKey,
    latitude,
    longitude,
    mapsURL,
    trackEvent = ()=>{},
    onBackClick,
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
    sunday,
    openingHours,
    message,
    rating,
    totalReviews = 0,
    theme,
}) => {

    const getLocationOpeningHoursHTML = (html) => {
        const splitRegex = /<br\s*\/?>/i;
        const regex = /^[a-z\-]+:\s*/i;
        if (html.split(splitRegex).reduce((p, v) => p && regex.test(v.trim()), true)) {
            // html = html.split(splitRegex).map(v => v.trim().replace(regex, '<div class="lad__location__hours__day">$&</div>')).join('<br />');
            html = html.split(splitRegex).map(v => {
                let _v = v.trim();
                let i = _v.indexOf(":");
                return `<div class="row"><div class="col-4">${_v.substring(0,i)}:</div><div class="col-8">${_v.substring(i + 1)}</div></div>`;
            }).join("");
        }
        return {__html: html};
    }

    const typeLabels = {
        "Sales": "Sales",
        "Service": "Service",
        "TradePartCentre": "Trade parts"
    };
    
    const hasBackButton = typeof onBackClick === 'function';
    const _theme = theme || DEFAULT_THEME;
    const auiTheme = (_theme === "dark" ? "light" : null);
    const _phone = phone || dealer.phone;
    const parsedPhoneNum = phoneParse(_phone, 'AU');
    let telLink = _phone;
    if (parsedPhoneNum && parsedPhoneNum.phone) {
        telLink = '+61' + parsedPhoneNum.phone;
    }

    return (
        <div className="locate-location p-4">

            <div className="row align-items-center no-gutters mb-3">
                {hasBackButton && <div className="col-auto">
                    <button className="aui-button locate-location__back" onClick={onBackClick}><IconBack large /></button>
                </div>}
                <div className="col">
                    <h5 className="mb-2">{name} {dealer && <>- {typeLabels[type]}</>}</h5>
                </div>
            </div>

            {message && <div className="locate-location__message" dangerouslySetInnerHTML={{__html: message}} />}

            {totalReviews > 0 && <p className="locate__rating mb-3">
                <span><RatingStar /> {rating}</span> {totalReviews} reviews
            </p>}

            {_phone && <p className="locate__icon-line mb-3">
                <VoiceCall1 small /> <a href={`tel:${telLink}`} className="aui-textlink" onClick={() => { trackEvent('PhoneClicked'); }}>{_phone}</a>
            </p>}
            {email && <p className="locate__icon-line mb-3">
                <DirectMail small /> <a href={`mailto:${email}`} className="aui-textlink" onClick={() => { trackEvent('EmailClicked'); }}>{emailLinkText || email}</a>
            </p>}
            {website && <p className="locate__icon-line mb-3">
                <Home small /> <a href={website} className="aui-textlink" target="_blank" rel="noopener noreferrer" onClick={() => { trackEvent('WebsiteClicked'); }}>{websiteLinkText || website.replace(/^http:\/\//, '').replace(/^https:\/\//, '')}</a>
            </p>}
            <p className="locate__icon-line mb-3">
                <Geofence small /> {address}<br />{suburb} {state} {postcode}
            </p>
                
            {openingHours && !monday && <div className="locate__hours p-4 mb-4" dangerouslySetInnerHTML={ getLocationOpeningHoursHTML(openingHours) } />}
            {(monday || tuesday || wednesday || thursday || friday || saturday || sunday) && <ul className="locate__hours p-4 mb-4">
                <li><span className="day">Monday:</span><span className="time">{monday}</span></li>
                <li><span className="day">Tuesday:</span><span className="time">{tuesday}</span></li>
                <li><span className="day">Wednesday:</span><span className="time">{wednesday}</span></li>
                <li><span className="day">Thursday:</span><span className="time">{thursday}</span></li>
                <li><span className="day">Friday:</span><span className="time">{friday}</span></li>
                <li><span className="day">Saturday:</span><span className="time">{saturday}</span></li>
                <li><span className="day">Sunday:</span><span className="time">{sunday}</span></li>
            </ul>}

            <div className="locate__ctas mt-5">
                {dealer && type === "Sales" &&
                    <Button variant="primary" theme={auiTheme}
                        href={`https://forms.audi.com.au/request-a-test-drive?d=${dealer.dealerCode}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => { trackEvent('BookTestDriveClicked'); }}>Request a test drive</Button>
                }
                {dealer && type === "Service" && webKey &&
                    <Button variant="primary" theme={auiTheme}
                        href={`https://forms.audi.com.au/book-a-service/${dealer.dealerCode}/${id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => { trackEvent('BookAServiceClicked'); }}>Book a service</Button>
                }
                {((latitude && longitude) || mapsURL) &&
                    <Button variant="secondary" theme={auiTheme}
                        href={mapsURL ? mapsURL : `https://www.google.com/maps/dir//${latitude},${longitude}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => { trackEvent('DirectionsClicked'); }}>Directions</Button>
                }
            </div>
        </div>
    );
}

export default Location;
